import * as yup from 'yup'

export const reservationPoolValidationSchema = yup.object().shape({
    name: yup.string().trim().required('Please enter the name').max(100),
    externalChannel: yup.string().required('Please select the retailer'),
})
